// JSON-LD (schema.org) for public pages. Describes only what the page already
// shows — search engines discount structured data the visitor can't see.
import site from './site.json';

const ORG_ID = `${site.origin}/#organization`;
const WEBSITE_ID = `${site.origin}/#website`;

const organization = {
  '@type': 'Organization',
  '@id': ORG_ID,
  name: site.organization.name,
  legalName: site.organization.legalName,
  url: site.origin,
  logo: site.origin + site.organization.logo,
  sameAs: site.organization.sameAs,
};

const website = {
  '@type': 'WebSite',
  '@id': WEBSITE_ID,
  name: site.siteName,
  url: site.origin,
  publisher: { '@id': ORG_ID },
};

// "LatentCode CLI reference · LatentStack Docs" → "LatentCode CLI reference"
const headline = (page) => page.title.split(' · ')[0];

// Docs › Section › Page. A section's overview is its first page in site.json.
function breadcrumbs(page) {
  const docs = site.pages.find((p) => p.path === '/docs');
  const trail = [{ name: 'Docs', path: docs.path }];
  if (page.path !== docs.path) {
    const root = site.pages.find((p) => p.section === page.section);
    trail.push({ name: page.section, path: root.path });
    if (root.path !== page.path) trail.push({ name: headline(page), path: page.path });
  }
  return {
    '@type': 'BreadcrumbList',
    itemListElement: trail.map((t, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: t.name,
      item: site.origin + t.path,
    })),
  };
}

export function schemaFor(page) {
  const url = site.origin + page.path;
  const graph = [organization, website];
  const product = site.products[page.path];
  if (product) {
    graph.push({
      '@type': 'SoftwareApplication',
      name: product.name,
      applicationCategory: product.applicationCategory,
      operatingSystem: product.operatingSystem,
      description: page.description,
      url,
      publisher: { '@id': ORG_ID },
    });
  }
  if (page.path.startsWith('/docs')) {
    graph.push(
      {
        '@type': 'TechArticle',
        headline: headline(page),
        description: page.description,
        url,
        mainEntityOfPage: url,
        isPartOf: { '@id': WEBSITE_ID },
        publisher: { '@id': ORG_ID },
        inLanguage: 'en',
      },
      breadcrumbs(page),
    );
  }
  return { '@context': 'https://schema.org', '@graph': graph };
}
